// Recovered compiled webpack factory 34576. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { l: () => p });
  var n = i(40479),
    s = i(98387),
    r = i(39622),
    o = i(12709),
    a = i(32246),
    l = i(31439);
  let h = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust",
  ]);
  var u = i(36795),
    d = i(33452),
    c = i(35043);
  class p extends o.b {
    constructor() {
      (super(...arguments),
        (this.type = "svg"),
        (this.isSVGTag = !1),
        (this.measureInstanceViewportBox = r.ge));
    }
    getBaseTargetFromProps(t, e) {
      return t[e];
    }
    readValueFromInstance(t, e) {
      if (n.f.has(e)) {
        let t = (0, s.D)(e);
        return (t && t.default) || 0;
      }
      return ((e = h.has(e) ? e : (0, a.I)(e)), t.getAttribute(e));
    }
    scrapeMotionValuesFromProps(t, e, i) {
      return (0, c.x)(t, e, i);
    }
    build(t, e, i) {
      (0, l.B)(t, e, this.isSVGTag, i.transformTemplate, i.style);
    }
    renderInstance(t, e, i, n) {
      for (let i in ((0, d.e)(t, e, void 0, n), e.attrs))
        t.setAttribute(h.has(i) ? i : (0, a.I)(i), e.attrs[i]);
    }
    mount(t) {
      ((this.isSVGTag = (0, u.n)(t.tagName)), super.mount(t));
    }
  }
}
